import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogHeader, DialogTitle } from "~/common/mui";
import { PackagingSelection } from "~/domains/product/components/PackagingSelection/PackagingSelection";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

interface SelectPackagingDialogProps {
  open: boolean;
  onClose: () => void;
  selectedPackCode: string;
  product: ProductDescriptor;
  onSelectPackCode: (packCode: string) => void;
}

export const SelectPackagingDialog = ({
  open,
  onClose,
  selectedPackCode,
  product,
  onSelectPackCode,
}: SelectPackagingDialogProps) => {
  const { t } = useTranslation();
  const [internalSelectedPackCode, setInternalSelectedPackCode] = useState(selectedPackCode);
  useEffect(() => {
    setInternalSelectedPackCode(selectedPackCode);
  }, [selectedPackCode]);

  const handleConfirm = () => {
    onSelectPackCode(internalSelectedPackCode);
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="desktop-s">
      <DialogHeader onClose={onClose}>
        <DialogTitle sx={{ p: 0 }}>{t("cartPage.table.content.choosePackaging")}</DialogTitle>
      </DialogHeader>
      <DialogContent>
        <PackagingSelection
          selectedCode={internalSelectedPackCode}
          onSelectCode={setInternalSelectedPackCode}
          product={product}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button onClick={handleConfirm}>{t("common.select")}</Button>
      </DialogActions>
    </Dialog>
  );
};
